import { Step } from 'react-joyride';

const getBonosTourSteps = (isMobile: boolean): Step[] => {
  const suffix = isMobile ? '-mobile' : '-desktop';

  const allSteps: (Step & { desktopOnly?: boolean })[] = [
    {
      target: '.tour-title',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Bienvenido a la sección de <strong>Bonos</strong>. Aquí puedes crear,
          editar y revisar los paquetes de servicios que vendes a tus
          clientes. Los bonos ayudan a fidelizar y a ofrecer descuentos por
          volumen.
        </div>
      ),
      placement: 'bottom',
      disableBeacon: true,
    },
    {
      target: '.tour-add-btn',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Pulsa <strong>Añadir bono</strong> para crear un nuevo paquete.
          Deberás definir:
          <ul style={{ margin: '8px 0 0 16px' }}>
            <li>
              <strong>Nombre</strong> del bono
            </li>
            <li>
              <strong>Servicio asociado</strong>
            </li>
            <li>
              <strong>Cantidad</strong> de servicios incluidos
            </li>
            <li>
              <strong>Precio total</strong> del bono
            </li>
            <li>
              <strong>Duración</strong> (días de validez)
            </li>
            <li>
              Y si el bono está <strong>activo</strong> o no
            </li>
          </ul>
          <br />
          Los bonos activos podrán ser comprados por los clientes y usados
          para pagar reservas.
          <br />
          <br />
          <strong>Ejemplo:</strong> 5 sesiones de masaje por 200 €, válido 90
          días.
        </div>
      ),
      placement: 'left',
      disableBeacon: true,
    },
    {
      target: '.tour-filter-input',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Usa este buscador para encontrar bonos rápidamente por su nombre,
          servicio, precio o duración. Ideal cuando tienes muchos registros.
        </div>
      ),
      placement: 'bottom',
      disableBeacon: true,
    },
    {
      target: '.tour-table-head',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Aquí verás todos los <strong>bonos registrados</strong>. Haz clic en
          cualquier cabecera de columna para <strong>ordenar</strong> la
          lista — por ejemplo, por precio o por duración.
        </div>
      ),
      placement: 'top',
      disableBeacon: true,
      desktopOnly: true,
    },
    {
      target: '.tour-activo-badge',
      content: (
        <div style={{ textAlign: 'justify' }}>
          <strong>Activo</strong> indica si el bono está disponible para la
          venta ahora mismo.
          <br />
          <br />
          <span style={{ color: '#10B981', fontWeight: 'bold' }}>✔ Sí</span>{' '}
          — los clientes pueden comprarlo y usarlo para pagar reservas.
          <br />
          <span style={{ color: '#EF4444', fontWeight: 'bold' }}>✘ No</span>{' '}
          — queda pausado: nadie puede comprarlo, pero los bonos ya vendidos
          siguen siendo válidos hasta su fecha de caducidad.
        </div>
      ),
      placement: 'right',
      disableBeacon: true,
      desktopOnly: true,
    },
    {
      target: `.tour-edit-btn${suffix}`,
      content: (
        <div style={{ textAlign: 'justify' }}>
          Pulsa el <strong>lápiz </strong> para editar un bono existente.
          Puedes cambiar el nombre, el servicio, el precio, la cantidad o su
          vigencia. Úsalo también para desactivar temporalmente un bono sin
          borrarlo.
        </div>
      ),
      placement: 'left',
      disableBeacon: true,
    },
    {
      target: `.tour-delete-btn${suffix}`,
      content: (
        <div style={{ textAlign: 'justify' }}>
          Pulsa la <strong>papelera </strong> para eliminar un bono
          definitivamente. Te pedirá confirmación antes de borrarlo.
          <br />
          <br />
          Si el bono <strong>ya se ha vendido</strong> a algún cliente, el
          botón aparecerá <strong>atenuado y no podrás eliminarlo</strong>:
          borrarlo dejaría sin efecto los bonos que tus clientes ya han
          comprado. En ese caso, si no quieres seguir ofreciéndolo, edítalo y
          <strong> desactívalo</strong> — dejará de venderse, pero los bonos ya
          comprados seguirán siendo válidos hasta caducar.
        </div>
      ),
      placement: 'left',
      disableBeacon: true,
    },
    {
      target: '.tour-pagination',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Si tienes muchos bonos, usa la <strong>paginación</strong> para
          moverte entre páginas. También puedes cambiar cuántos se muestran a
          la vez.
        </div>
      ),
      placement: 'top',
      disableBeacon: true,
    },
    {
      target: 'body',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Al crear o editar un bono se abre un <strong>formulario</strong>{' '}
          donde defines el servicio incluido, la cantidad, el precio total y
          la duración.
          <br />
          <br />
          Por ejemplo:
          <br />• 5 sesiones de masaje por 200 €
          <br />• 10 clases de yoga válidas por 60 días
          <br />• 3 cortes de pelo por 50 €
          <br />
          <br />
          Al guardar, el bono quedará disponible para venta y uso por tus
          clientes.
        </div>
      ),
      placement: 'center',
      disableBeacon: true,
    },
  ];

  return allSteps
    .filter((s) => !(isMobile && s.desktopOnly))
    .map(({ desktopOnly, ...step }) => step);
};

export default getBonosTourSteps;